export const BASE_URL = 'https://api.makesomenoise.kr'
